export default __webpack_public_path__ + "static/media/map_pin_alvorlig_avvik_fra_kontrollør.2e9a1f5c.svg";